import axios from 'axios';
import {Folder} from "@/types";


export interface CreateFolderRequest {
    name: string;
}

export interface UpdateFolderRequest {
    name: string;
}

export interface MoveJobsRequest {
    job_ids: number[];
    folder_id?: string | null;
}

export const folderService = {
    async createFolder(data: CreateFolderRequest): Promise<Folder> {
        const response = await axios.post(route('folders.store'), data);
        return response.data;
    },

    async updateFolder(folderId: string, data: UpdateFolderRequest): Promise<Folder> {
        const response = await axios.put(route('folders.update', folderId), data);
        return response.data;
    },

    async deleteFolder(folderId: string): Promise<void> {
        await this.deleteFolders([folderId]);
    },

    async deleteFolders(folderIds: string[]): Promise<void> {
        await axios.post(route('folders.bulk-delete'), {ids: folderIds});
    },

    async getFolders(): Promise<Folder[]> {
        const response = await axios.get(route('folders.index'));
        return response.data;
    },

    async moveJobs(data: MoveJobsRequest): Promise<void> {
        await axios.post(route('folders.move-jobs'), data);
    }
};
